export default {
  navbar: {
    about: 'sobre',
    whatido: 'o que faço',
    works: 'trabalhos',
    journey: 'jornada',
    contact: 'contato',
    theme: 'Tema',
  },
  footer: {
    rights: 'Todos os direitos reservados',
    made: 'Feito com',
    cta: {
      title1: 'vamos construir',
      title2: 'algo',
      titleAccent: 'extraordinário',
      description: 'Tem um projeto em mente ou quer apenas se conectar? Envie uma mensagem',
    },
  },
  notFound: {
    title: 'Página Não Encontrada',
    description: 'Desculpe, a página que você está procurando não existe ou foi movida.',
    goHome: 'Ir para Início',
    goBack: 'Voltar',
  },
  close: 'Fechar',
  readMore: 'Leia mais',
  readLess: 'Leia menos',
  tiltToExplore: 'Inclina para explorar',
  tapToExplore: 'Toque para explorar',
}
